import { render } from "./Officials.vue?vue&type=template&id=91a47228&scoped=true"
import script from "./Officials.vue?vue&type=script&lang=js"
export * from "./Officials.vue?vue&type=script&lang=js"

import "./Officials.vue?vue&type=style&index=0&id=91a47228&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a47228"]])

export default __exports__